import { shallowDiff } from '@hypatia/utils/comparators/shallow-diff'
import { AnySourceStream, Stream } from '../stream'

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        changes(): Stream<DV, DE, DC, Partial<DV>, DE, DC>
    }
}

Stream.prototype.changes = function <V, E, C, T = V>(this: AnySourceStream<V, E, C>) {
    return this.reduce(
        ({ lastValue }, currentValue) => {
            return {
                changes: shallowDiff(lastValue, currentValue),
                lastValue: currentValue,
            }
        },
        { changes: {}, lastValue: {} }
    ).map((x) => x.changes)
}
